import { ClassAttributes, FunctionComponent, HTMLAttributes, MouseEvent } from 'react'
import css from './clickableIcon.module.css'

interface IProps {
  icon: FunctionComponent<ClassAttributes<SVGSVGElement> & HTMLAttributes<SVGSVGElement>>
  active?: boolean // если true, active-эффект сохраняется
  size: 'default'
  onClick: (ev: MouseEvent<HTMLDivElement>) => void
}

/* Рендерит передданую иконку с паддингом, hover и active эффектами  */
const ClickableIcon = (props: IProps) => {
  const Icon = props.icon

  return (
    <div className={css.wrapper} onClick={props.onClick} data-active={Boolean(props.active)}>
      <Icon className={css.icon} data-size={props.size} />
    </div>
  )
}

export default ClickableIcon
